import styled from 'styled-components/macro';
import { colorAccentSuccess200, colorBrandGolfGreen } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
export const IconWrapperContainer = styled.div `
  padding: 12px;
  background-color: ${colorAccentSuccess200};
  border-radius: ${CORNER_RADIUS.circle};
`;
export const IconWrapper = styled.div `
  padding: 12px;
  background-color: ${colorBrandGolfGreen};
  border-radius: ${CORNER_RADIUS.circle};
`;
